import { DashboardLayout } from "@/components/layout/DashboardLayout";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Users, Calendar, Upload, FileText, Settings } from "lucide-react";

export default function HR() {
  const navigate = useNavigate();

  const modules = [
    {
      title: "Employee Management",
      description: "Create, edit, and delete employee records",
      icon: Users,
      path: "/hr/employees",
      color: "text-primary",
    },
    {
      title: "Holiday Management",
      description: "Manage annual calendar and holidays",
      icon: Calendar,
      path: "/hr/holidays",
      color: "text-success",
    },
    {
      title: "Data Upload",
      description: "Upload employee data and calendar in bulk",
      icon: Upload,
      path: "/hr/upload",
      color: "text-warning",
    },
    {
      title: "Team Management",
      description: "Manage teams and structures",
      icon: Users,
      path: "/teams",
      color: "text-info",
    },
    {
      title: "Leave Quota Management",
      description: "Set and manage yearly leave quotas",
      icon: Settings, // Switched to Settings for Quota, need to import
      path: "/leave-quotas",
      color: "text-purple-500",
    },
    {
      title: "Reports",
      description: "View leave statistics and reports",
      icon: FileText,
      path: "/reports",
      color: "text-accent",
    },
  ];

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-3xl font-bold text-foreground">HR Portal</h2>
          <p className="text-muted-foreground mt-1">
            Manage employees, holidays, and system data
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {modules.map((module) => {
            const Icon = module.icon;
            return (
              <Card
                key={module.path}
                className="hover:shadow-soft transition-all cursor-pointer group"
                onClick={() => navigate(module.path)}
              >
                <CardHeader>
                  <div className="flex items-start justify-between">
                    <div className="h-12 w-12 rounded-lg bg-muted flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Icon className={`h-6 w-6 ${module.color}`} />
                    </div>
                  </div>
                  <CardTitle className="mt-4">{module.title}</CardTitle>
                  <CardDescription>{module.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <Button
                    variant="ghost"
                    className="w-full group-hover:bg-muted/50"
                  >
                    Open Module
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
}
